module.exports = "/assets/js/7f014c2cf47653503342ff8297b3d739.svg";